export const CONNECTOR_URL = `/assets/components/pageviews/connector.php`;
export const RequestAction = {
  ADD_VIEW: `add_view`
};
